module.exports = __webpack_public_path__ + "static/Cloé-05becea6ad1a9cd903ba88531dd6bc6a.png";